import React from "react";
import { useMutation } from "@apollo/client";
import { gql } from "@apollo/client";

import { Backdrop } from "@mui/material";
import { CloudUpload as UploadIcon } from "mdi-material-ui";

import FileUpload from "components/common/FileUpload";

const MUTATION = gql`
  mutation ($orderId: ID!, $file: FileInput!) {
    AttachFileOrder(orderId: $orderId, file: $file) {
      order {
        id
      }
    }
  }
`;

export default function OrderActionFile({ order, className }) {
  const [attachFile] = useMutation(MUTATION);

  return (
    <FileUpload
      uploadPath={`orders/${order.id}`}
      isPublic={false}
      onUpload={({ path, isPublic }) =>
        attachFile({
          variables: {
            orderId: order.id,
            file: { path, isPublic },
          },
        })
      }
    >
      {({ canDrop, isOver }) => (
        <div>
          <Backdrop
            open={canDrop}
            sx={{
              color: "#fff",
              zIndex: (t) => t.zIndex.drawer,
              "& svg": {
                width: "15vw !important",
                height: "15vw !important",
              },
            }}
          >
            <UploadIcon />
          </Backdrop>
        </div>
      )}
    </FileUpload>
  );
}

OrderActionFile.fragments = {
  order: gql`
    fragment OrderActions_File_order on Order {
      id
    }
  `,
};
